import { type FieldId, type Locale } from "./lib/types/types";

export const DEFAULT_LOCALE: Locale = "en-US";

export const ACCEPTED_DOC_MIME_TYPES: string[] = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "application/pdf",
];

export const ACCEPTED_DOC_TYPES: string[] = [".jpg", ".jpeg", ".png", ".pdf"];
export const MAX_DOC_UPLOAD_DOCS_ALLOWED: number = 3;
export const UPLOAD_FILE_PREFIX: string = "file";

export const QUERY_STRING_STEP_OVERRIDE: string = "mockStep";
export const QUERY_STRING_SEGMENT_OVERRIDE: string = "mockSegment";
export const QUERY_STRING_SUBSEGMENT_OVERRIDE: string = "mockSubSegment";
export const QUERY_STRING_ERRORID_OVERRIDE: string = "mockErrorId";
export const QUERY_STRING_ERRORDETAILID_OVERRIDE: string = "mockErrorDetailId";
export const QUERY_STRING_REWARD_CODE_OVERRIDE: string = "mockRewardCode";
export const QUERY_STRING_REDIRECT_URL_OVERRIDE: string = "mockRedirectUrl";
export const QUERY_STRING_REMEMBER_ME_OVERRIDE: string = "mockConsumerInfoState"; // ?mockConsumerInfoState=consumerFound | consumerNotFound
export const QUERY_STRING_ID_CHECK_LOOP_SERVICE_TYPE_OVERRIDE: string =
  "mockIdCheckLoopServiceType"; // ?mockIdCheckLoopServiceType=ID_CHECK | ID_CHECK_LIVENESS
export const QUERY_STRING_DOC_SELECTED: string = "mockDocSelected"; // mock the state where a consumer as already selected a file and is about to click the "continue" button on the docUpload step
export const QUERY_STRING_PREV_STEP_OVERRIDE: string = "mockPreviousStep";
export const QUERY_STRING_THIRD_PARTY_PROVIDER_OVERRIDE: string = "thirdPartyLoopProvider";
export const QUERY_STRING_SSO_METHOD: string = "ssoMethod";
export const QUERY_STRING_INSTALL_PAGE_URL: string = "installPageUrl";
export const QUERY_STRING_INSTALL_TYPE: string = "installType";
export const QUERY_STRING_LAYOUT: string = "layout"; // verify app's "?layout=landing"
export const QUERY_STRING_EXTERNAL_USER_ID: string = "externalUserId";
export const QUERY_STRING_CAPTCHA_ERROR_OVERRIDE: string = "mockCaptchaState";

export const SSN_STRING_LENGTH: number = 9;
export const DEFAULT_MINIMUM_ORG_SEARCH_VALUE_LENGTH: number = 1;

export const DEFAULT_PRIVACY_POLICY_HOST = "www.sheerid.com";
export const DEFAULT_PRIVACY_POLICY_URL = "https://www.sheerid.com/privacy-policy/";
export const SHEERID = "SheerID";

export const FEEDBACK_FORM_URL =
  "https://verify.sheerid.com/verification-support/feedback.html?token=";
export const SUPPORT_URL = "https://support.sheerid.com";
export const CLOUDFLARE_PRIVACY_POLICY_URL = "https://www.cloudflare.com/privacypolicy/";

export const HTTP_REQUEST_TIMEOUT = 10000;
export const DEBOUNCE_TIMEOUT = 200;

export const inLightbox = "inLightbox";

export const AUTH_TOKEN_LENGTH = 6;

export const FIELD_IDS: FieldId[] = [
  "firstName",
  "lastName",
  "memberId",
  "organization",
  "birthDate",
  "email",
  "phoneNumber",
  "postalCode",
  "address1",
  "city",
  "state",
  "dischargeDate",
  "activeDutyStartDate",
  "status",
  "statuses",
  "docUpload",
  "country",
  "smsCode",
  "socialSecurityNumber",
  "marketConsentValue",
  "carrierConsentValue",
  "driverLicenseNumber",
  "overrideCode",
  "ebtCardNumber",
  "organizationEmail",
  "authenticationCode",
];
